import { motion } from 'framer-motion';
import { Names } from '../names/names';
import { EarthCanvas } from '../../canvas';
import { slideIn } from '../../../utils/motion';
import { ContentAreaStyles } from '../../../styles/styles';
import './contentArea.scss';

const ContentArea = () => {
  return (
    <div className="main-container mx-auto gap-10" id="main-container">
      <ContentAreaStyles
        initial={{ backgroundColor: '#0f0e0e', pointerEvents: 'none' }}
        animate={{ backgroundColor: 'transparent', pointerEvents: 'unset' }}
        exit={{
          opacity: [1, 1, 0],
          transition: { duration: 2, times: [0, 0.99, 1] },
        }}>
        <div className="names">
          <Names />
        </div>
        <motion.div
          variants={slideIn('right', 'tween', 0.2, 1)}
          className="xl:flex-1 xl:h-auto md:h-[550px] h-[350px] earth-canvas">
          <EarthCanvas />
        </motion.div>
      </ContentAreaStyles>
    </div>
  );
};

export default ContentArea;
